import { Cross2Icon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";
import { BiBadgeCheck } from "react-icons/bi";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";

import { Button } from "@/components/ui/button/button";
import { Input } from "@/components/ui/input/input";
import { DataTableViewOptions } from "./data-table-view-options";
import { DataTableFacetedFilter } from "./data-table-faceted-filter";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;

  const brokers = [
    {
      label: "Angel One",
      value: "ANGELONE",
    },
    {
      label: "Zerodha",
      value: "ZERODHA",
    },
    {
      label: "Alice Blue",
      value: "ALICEBLUE",
    },
    {
      label: "ICICI",
      value: "ICICI",
    },
    {
      label: "Upstox",
      value: "UPSTOX",
    },
  ];

  const assignedStatus = [
    {
      value: "true",
      label: "Assigned",
    },
    {
      value: "false",
      label: "Not Assigned",
    },
  ];

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Filter by name..."
          value={(table.getColumn("name")?.getFilterValue() as string) ?? ""}
          onChange={(event) =>
            table.getColumn("name")?.setFilterValue(event.target.value)
          }
          className="h-8 w-[150px] lg:w-[250px]"
        />

        {table.getColumn("broker") && (
          <DataTableFacetedFilter
            column={table.getColumn("broker")}
            title="Broker"
            options={brokers}
            Icon={BiBadgeCheck}
          />
        )}

        {table.getColumn("assignedStatus") && (
          <DataTableFacetedFilter
            column={table.getColumn("assignedStatus")}
            title="Assigned or not?"
            options={assignedStatus}
            Icon={MdOutlineAssignmentTurnedIn}
          />
        )}

        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>

      <DataTableViewOptions table={table} />
    </div>
  );
}
